if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.target.closest('[data-modal-prev], [data-modal-next]')) {
              event.stopImmediatePropagation();
            }
          },
          true
        );
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-modal-prev]')) this.showPreviousMedia();
          if (event.target.closest('[data-modal-next]')) this.showNextMedia();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      get activeIndex() {
        return this.mediaItems.findIndex((item) => item.classList.contains('active'));
      }

      showMediaByIndex(index) {
        const items = this.mediaItems;
        if (!items.length) return;

        const safeIndex = ((index % items.length) + items.length) % items.length;
        items.forEach((item) => item.classList.remove('active'));
        const activeMedia = items[safeIndex];
        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      showPreviousMedia() {
        const current = this.activeIndex;
        this.showMediaByIndex(current > -1 ? current - 1 : 0);
      }

      showNextMedia() {
        const current = this.activeIndex;
        this.showMediaByIndex(current > -1 ? current + 1 : 0);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
